/**
 * IIIF Structural properties
 *
 * - getCollections
 * - getManifests
 * - getMembers
 * - getSequences
 * - getCanvases
 * - getStructures / getRanges
 * - getOtherContent
 * - getImages
 */

var alwaysArray = function alwaysArray(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : maybeArray || [];
};

var getCollections = function getCollections(resource) {
  return Array.from(new Set([].concat(alwaysArray(resource.collections).filter(function (collection) {
    return collection.schema === 'collection';
  }).map(function (collection) {
    return collection.id;
  }), alwaysArray(resource.members).filter(function (member) {
    return member.schema === 'collection';
  }).map(function (member) {
    return member.id;
  }))));
};

var getManifests = function getManifests(resource) {
  return [].concat(alwaysArray(resource.manifests), alwaysArray(resource.collections).filter(function (collection) {
    return collection.schema === 'manifest';
  }).map(function (manifest) {
    return manifest.id;
  }));
};

var getMembers = function getMembers(resource) {
  return Array.from(new Set([].concat(alwaysArray(resource.members).map(function (member) {
    return member.id;
  }), alwaysArray(resource.collections).filter(function (collection) {
    return collection.schema === 'collection';
  }).map(function (collection) {
    return collection.id;
  }), resource.manifests || [], alwaysArray(resource.collections).filter(function (collection) {
    return collection.schema === 'manifest';
  }).map(function (collection) {
    return collection.id;
  }))));
};

var getRangeMembers = function getRangeMembers(resource) {
  return Array.from(new Set([].concat(alwaysArray(resource.members).map(function (member) {
    return member.id;
  }), resource.canvases || [], resource.ranges || [])));
};

var getRangeRanges = function getRangeRanges(resource) {
  return Array.from(new Set([].concat(alwaysArray(resource.members).filter(function (member) {
    return member.schema === 'range';
  }).map(function (member) {
    return member.id;
  }), resource.ranges || [])));
};

var getRangeCanvases = function getRangeCanvases(resource) {
  return Array.from(new Set([].concat(alwaysArray(resource.members).filter(function (member) {
    return member.schema === 'canvas';
  }).map(function (member) {
    return member.id;
  }), resource.canvases || [])));
};

var getSequences = function getSequences(resource) {
  return alwaysArray(resource.sequences);
};

var getCanvases = function getCanvases(resource) {
  return alwaysArray(resource.canvases);
};

var getStructures = function getStructures(resource) {
  return alwaysArray(resource.structures);
};

var getRanges = getStructures;

var getOtherContent = function getOtherContent(resource) {
  return alwaysArray(resource.otherContent).map(function (otherContent) {
    return otherContent.id;
  });
};

var getImages = function getImages(resource) {
  return alwaysArray(resource.images);
};

var getResource = function getResource(resource) {
  return resource ? resource.resource ? resource.resource.id : null : null;
};

var getResources = function getResources(resource) {
  return alwaysArray(resource.resources);
};

export { getSequences, getCanvases, getCollections, getImages, getManifests, getMembers, getOtherContent, getRanges, getRangeCanvases, getRangeMembers, getRangeRanges, getStructures, getResource, getResources };